import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import TeamLayout from "../Layouts/TeamLayout";
import AboutLayout from "../Layouts/AboutLayout";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import TermsConditions from "../Pages/TermsConditions";
import RefundCancellation from "../Pages/RefundCancellation";

export const router = createBrowserRouter([
    { path: "/",
      element: <App />
    },
    { path: "/team",
      element: <TeamLayout/>
    },
    {
        path: "/about",
        element: <AboutLayout/>
    },
    {
        path: "/privacy-policy",
        element: <PrivacyPolicy/>
    },
    {
        path: "/terms-conditions",
        element: <TermsConditions/>
    },
    {
        path: "/refund-cancellation",
        element: <RefundCancellation/>
    }
]);